import { useRouter } from 'next/router'
import React from 'react'
import styled from '@emotion/styled'
import Link from '../Link'

const AlertWrapper = styled.div`
  position: relative;
  z-index: 2;
  font-family: monospace;
  font-size: 1rem;
  font-weight: 500;
  color: black;
  padding: 0.3rem 0.5rem;
  background: linear-gradient(270deg, #ab66ff 0%, #14f195 101.39%);
  text-align: center;
  text-transform: uppercase;

  a:hover {
    color: #fff;
  }
`

const AlertTop = ({ to, message }: { to?: string; message: string }) => {
  if (to) {
    return (
      <AlertWrapper>
        <Link to={to} className="link-unstyled">
          {message}
        </Link>
      </AlertWrapper>
    )
  }
  return <AlertWrapper>{message}</AlertWrapper>
}

/**
 * Displays an Alert at the top of the window excluding
 * all the sub-pages that the alert message is linking to
 *
 * @returns {JSX.Element}
 */
function SitewideTopAlert({
  alertUrl = '',
  message,
  excluded = [],
}: {
  alertUrl?: string
  message: string
  excluded?: string[]
}) {
  const router = useRouter()

  const excludedPages = [...excluded, ...(alertUrl.length ? [alertUrl] : [])]

  if (
    excludedPages.length &&
    excludedPages.some((pathname) => router.pathname.includes(pathname))
  ) {
    return null
  }

  return <AlertTop to={alertUrl} message={message} />
}

export default SitewideTopAlert
